import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateTextConnect = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1318.41 307.89",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#002f75;}.d{fill:#ebf3ff;}.e{fill:#fafcff;}.f{fill:#fff1d6;}.g{fill:#6ba6ff;}.h{fill:#9ec5ff;}.i{fill:#bd0f0f;}.j{fill:#c5f6da;}.k{fill:#3f8bfd;}.l,.m{fill:#0c6734;}.m{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("rect", {
				className: "e",
				width: 1318.41,
				height: 307.89
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "d",
					x: 25,
					y: 82.03,
					width: 380.49,
					height: 180.61
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 63.04,
					y: 107.28,
					width: 304.4,
					height: 155.36
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M38.87,45.24H391.62c7.66,0,13.87,6.22,13.87,13.87v22.92H25v-22.92c0-7.66,6.22-13.87,13.87-13.87Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "j",
						cx: 47.22,
						cy: 63.64,
						r: 8.51
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "f",
						cx: 72.21,
						cy: 63.64,
						r: 8.51
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "i",
						cx: 97.19,
						cy: 63.64,
						r: 8.51
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "k",
					d: "M326.19,208.56h3.27c.02,.08,.03,.16,.06,.23l7.04,18.79c.58,1.56,2.79,1.56,3.38,0l7.04-18.79c.03-.08,.04-.16,.06-.23h83.27c12.11,0,21.92-9.81,21.92-21.92h0c0-12.11-9.81-21.92-21.92-21.92h-104.12c-12.11,0-21.92,9.81-21.92,21.92h0c0,12.11,9.81,21.92,21.92,21.92Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 378.25,
						cy: 186.64,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 410.18,
						cy: 186.64,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 346.32,
						cy: 186.64,
						r: 5.97
					})
				] })] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 318.57,
					y: 237.43,
					width: 32.37,
					height: 13.65,
					rx: 6.83,
					ry: 6.83
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "h",
					d: "M593.34,168.09l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "h",
					d: "M955.44,168.09l-30.84-17.8c-.67-.38-1.5,.1-1.5,.87v11.2h-62.06c-.53,0-.96,.43-.96,.96v11.29c0,.53,.43,.96,.96,.96h62.06v11.2c0,.77,.83,1.25,1.5,.87l30.84-17.8c.67-.38,.67-1.35,0-1.73Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M669.11,58.96V248.93c0,1.32,.29,2.57,.81,3.7,1.41,3.05,4.49,5.17,8.06,5.17h96.69c4.89,0,8.87-3.98,8.87-8.87V58.96c0-2.53-1.06-4.81-2.76-6.42-1.59-1.51-3.74-2.44-6.1-2.44h-96.69c-4.89,0-8.87,3.98-8.87,8.87Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M774.67,42.33h-96.69c-9.19,0-16.64,7.45-16.64,16.64V248.93c0,9.19,7.45,16.64,16.64,16.64h96.69c9.19,0,16.64-7.45,16.64-16.64V58.96c0-9.19-7.45-16.64-16.64-16.64Zm8.86,206.6c0,4.89-3.98,8.86-8.86,8.86h-96.69c-4.89,0-8.87-3.98-8.87-8.86V58.96c0-4.89,3.98-8.87,8.87-8.87h18.4s0,.09,0,.13c0,3.36,2.72,6.08,6.08,6.08h47.74c3.36,0,6.08-2.72,6.08-6.08,0-.04,0-.09,0-.13h18.4c4.89,0,8.86,3.98,8.86,8.87V248.93Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "c",
							d: "M723.18,124.24v7.04c-.04,7.61,6.01,13.85,13.62,14.05,7.19,0,13.18-5.5,13.8-12.66,.11-1.05,.16-3.75,.16-4.81s-.05-3.75-.16-4.8c-.63-7.59-7.3-13.24-14.89-12.6-2.56,.21-5.01,1.14-7.08,2.67-.12,.14-.12,.35,0,.48l2.88,4.78c.09,.14,.27,.18,.4,.09,.02-.01,.04-.03,.05-.04,3.2-2.7,7.99-2.3,10.7,.91,.91,1.08,1.5,2.39,1.71,3.78,.26,3.12,.26,6.25,0,9.37-.51,3.77-3.73,6.58-7.53,6.57-1.97-.03-3.85-.85-5.22-2.26-1.39-1.42-2.17-3.34-2.16-5.33v-7.04c.04-7.63-6.04-13.88-13.67-14.05-7.17,.03-13.13,5.54-13.73,12.68-.16,1.03-.16,3.72-.16,4.8s.03,3.75,.16,4.8c.64,7.59,7.32,13.22,14.91,12.58,2.54-.22,4.97-1.13,7.02-2.65,.13-.13,.14-.34,.03-.48l-2.91-4.77c-.1-.12-.28-.14-.4-.05-3.21,2.7-8,2.29-10.7-.91-.91-1.08-1.5-2.4-1.71-3.8-.26-3.12-.26-6.25,0-9.37,.52-3.75,3.72-6.55,7.51-6.56,1.98,.03,3.86,.84,5.23,2.26,1.39,1.43,2.16,3.34,2.15,5.33h-.02Z"
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "c",
							x: 693.17,
							y: 186.56,
							width: 66.3,
							height: 3.15,
							rx: 1.58,
							ry: 1.58
						}),
						/* @__PURE__ */ _jsxs("g", { children: [
							/* @__PURE__ */ _jsx("rect", {
								className: "c",
								x: 699.95,
								y: 171.61,
								width: 13.27,
								height: 3.15,
								rx: 1.58,
								ry: 1.58
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "c",
								x: 719.69,
								y: 171.61,
								width: 13.27,
								height: 3.15,
								rx: 1.58,
								ry: 1.58
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "c",
								x: 739.43,
								y: 171.61,
								width: 13.27,
								height: 3.15,
								rx: 1.58,
								ry: 1.58
							})
						] })
					] })
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "j",
					cx: 806.16,
					cy: 97.21,
					r: 33.57
				}), /* @__PURE__ */ _jsx("path", {
					className: "m",
					d: "M802.93,82.16c-5.58,1.44-9.7,6.5-9.7,12.53v8.63c0,.79-.65,1.44-1.44,1.44-1.59,0-2.88,1.29-2.88,2.88v2.16c0,.4,.32,.72,.72,.72h33.06c.4,0,.72-.33,.72-.72v-2.16c0-1.59-1.29-2.88-2.88-2.88-.79,0-1.44-.64-1.44-1.44v-8.63c0-6.03-4.12-11.1-9.7-12.53v-1.49c0-1.79-1.45-3.24-3.23-3.24s-3.23,1.45-3.23,3.24v1.49Zm-1.8,29.78h10.06c0,2.78-2.25,5.03-5.03,5.03s-5.03-2.25-5.03-5.03Z"
				})] }),
				/* @__PURE__ */ _jsx("path", {
					className: "k",
					d: "M1019.8,131.26h227.78c7.05,0,12.76,5.71,12.76,12.76v41.77c0,7.05-5.71,12.76-12.76,12.76h-106.08l-5.53,18.9c-1.27,4.35-7.41,4.39-8.75,.07l-5.87-18.96h-101.55c-7.05,0-12.76-5.71-12.76-12.76v-41.77c0-7.05,5.71-12.76,12.76-12.76Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
					className: "j",
					cx: 1265.57,
					cy: 119.84,
					r: 37.5
				}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "l",
					d: "M1283.15,119.92c1.07-.62,1.73-1.82,1.57-3.14-.21-1.65-1.73-2.81-3.38-2.81h-10.32c.08-.21,.21-.5,.29-.74,.62-1.57,1.77-4.46,1.77-7.43,0-3.34-2.35-5.37-3.96-5.49-.99-.04-1.73,.58-1.9,1.69-.29,2.1-1.69,5.2-2.27,6.4-.17,.37-.37,.7-.66,.99-.95,1.07-3.34,3.71-5.61,5.28,0,.08,.04,.21,.04,.29v19.77c0,.17-.04,.33-.04,.5,3.88,1.11,7.39,1.65,11.23,1.65h8.79c1.53,0,2.97-1.03,3.26-2.52,.25-1.24-.21-2.35-1.03-3.1,1.4-.33,2.48-1.61,2.48-3.1,0-.95-.41-1.82-1.11-2.39,1.4-.33,2.48-1.61,2.48-3.1,0-1.16-.62-2.19-1.61-2.77Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "l",
					d: "M1255,113.24h-6.89c-.95,0-1.73,.78-1.73,1.73v19.77c0,.95,.78,1.73,1.73,1.73h6.89c.95,0,1.73-.78,1.73-1.73v-19.73c0-.99-.74-1.77-1.73-1.77Z"
				})] })] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 1035.5,
					y: 149.54,
					width: 157.22,
					height: 7.48,
					rx: 3.74,
					ry: 3.74
				}), /* @__PURE__ */ _jsx("rect", {
					className: "e",
					x: 1035.5,
					y: 170.6,
					width: 128.41,
					height: 7.48,
					rx: 3.74,
					ry: 3.74
				})] })
			]
		})
	]
});
export default SvgEmptyStateTextConnect;
